import React, { useState } from "react";
import Modal from "react-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faCopy, faPaste } from "@fortawesome/free-solid-svg-icons";

Modal.setAppElement("#root"); // Required for accessibility

let copiedRowGlobal = null;

const ActionButtonsRenderer = ({ data, api, url, node }) => {
  if (node.rowPinned) return null;

  const deleteButtonRef = React.useRef(null);

  const [isModalOpen, setIsModalOpen] = useState(false);

  React.useEffect(() => {
    if (isModalOpen) {
      // Delay focus slightly to ensure modal is rendered
      const timer = setTimeout(() => {
        deleteButtonRef.current?.focus();
      }, 10);

      return () => clearTimeout(timer);
    }
  }, [isModalOpen]);

  React.useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setIsModalOpen(false);
      }
    };

    if (isModalOpen) {
      window.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isModalOpen]);

  const handleCopy = () => {
    copiedRowGlobal = { ...data };
    console.log("Row copied:", copiedRowGlobal);
  };

  const handlePaste = () => {
    if (!copiedRowGlobal) return;

    const newRow = { ...copiedRowGlobal, Id: null };
    api.applyTransaction({ add: [newRow] });
    console.log("Row pasted:", newRow);
  };

  const handleDeleteConfirm = () => {
    const rowId = data.id;
    if (!rowId || !url) return;

    fetch(`${url}/${rowId}`, {
      method: "DELETE",
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to delete");
        api.applyTransaction({ remove: [data] });
      })
      .catch((err) => console.error("Delete error:", err))
      .finally(() => setIsModalOpen(false));
  };

  return (
    <>
      <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
        {/*
        <button
          onClick={handleCopy}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            color: "#003645",
          }}
          title="Copy row"
          aria-label="Copy row"
        >
          <FontAwesomeIcon icon={faCopy} />
        </button>

        <button
          onClick={handlePaste}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            color: "#003645",
          }}
          title="Paste row"
          aria-label="Paste row"
        >
          <FontAwesomeIcon icon={faPaste} />
        </button>
        */}
        <button
          onClick={() => setIsModalOpen(true)}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            color: "red",
          }}
          title="Delete row"
          aria-label="Delete row"
        >
          <FontAwesomeIcon icon={faTrash} />
        </button>
      </div>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        contentLabel="Confirm Deletion"
        style={{
          content: {
            width: "330px",
            margin: "auto",
            padding: "0px",
            borderRadius: "6px",
            border: "0px solid #ccc",
            fontSize: "14px",
            overflow: "hidden",
            zIndex: 1001,
            position: "relative",
          },
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            zIndex: 1000,
          },
        }}
      >
        <h3
          style={{
            marginTop: 0,
            backgroundColor: "#F43A4F",
            width: "100%",
            color: "white",
            padding: "8px 12px",
            fontSize: "16px",
            boxSizing: "border-box",
            borderTopLeftRadius: "6px",
            borderTopRightRadius: "6px",
            borderBottomLeftRadius: "0",
            borderBottomRightRadius: "0",
          }}
        >
          Confirm Deletion
        </h3>{" "}
        <p style={{ padding: "16px 16px 0px 16px" }}>
          Are you sure you want to delete this row?
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "8px",
            padding: "0px 16px 16px",
            flexWrap: "wrap",
            textAlign: "cen",
          }}
        >
          <button
            onClick={() => setIsModalOpen(false)}
            style={{
              backgroundColor: "#ffffff",
              color: "#000000",
              border: "1px solid #F43A4F",
              padding: "6px 12px",
              borderRadius: "20px",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>

          <button
            ref={deleteButtonRef}
            onClick={handleDeleteConfirm}
            style={{
              backgroundColor: "#F43A4F",
              color: "white",
              border: "none",
              padding: "6px 12px",
              borderRadius: "20px",
              cursor: "pointer",
            }}
          >
            Delete
          </button>
        </div>
      </Modal>
    </>
  );
};

export default ActionButtonsRenderer;
